export default function getNationalitiesList() {
    const requestOptions = {
        method: 'GET',
        // headers: { 'Content-Type': 'application/json' },
    };
    return fetch('/shared/api/getNationalityList',requestOptions).then((response) => response.json())
}